import { ENTRY_CHANNEL } from "./channel";
// 本地调试php变量
if (process.env.NODE_ENV === "development") {
  global.taifuli = 0; // 泰福利标识
  global.third_party_user = "0"; // 泰福利标识
  global.SHOW_MEDICAL_CARD = 0; // 是否显示购买体检卡入口
  global.SHOW_MEDICAL_CARD_LIST = "1";
  global.ENTRANCE = "";
  global.preActivityStartTime = new Date("2018/10/16 23:59:59").getTime();
  global.activityStartTime = new Date("2018/10/17").getTime();
  global.activityEndTime = new Date("2018/10/22 23:59:59").getTime();
  global.appPath = "apis/apps/wechat/";
  global.API_PATH = "apis/apps/api/";
  global.cos_prefix = "https://public-10006067.file.myqcloud.com/";
  global.websit_path = "http://dev.daishutijian.com/static/wechat/";
  global.sports_path = "http://dev.daishutijian.com/apps/sports/";
  global.appsRootPath = "apis/apps/";
  global.company_id = "0"; // 是否团检用户
  global.res_version = 123; // 版本号
  global.BROSWER_TYPE = "1"; // 访问渠道
  global.isCcb = false; // 建行标识
  global.isTester = 1;
  global.ISWEBVIEW = false;
  global.user_id = 123245;
  global.TESTUSERID = [123245];
  global.cssType = 1;
  global.ZTPREFIX = "http://life.daishujiankang.com/nar-web/h5/pre/";
  global.ZTPREFIXLOGIN =
    "http://test.daishutijian.com/tijian/apps/wechat/home/covid_entrance";
  global.checkWebview = function (fn) {
    // 微信小程序标识
    fn(false);
  };
  global.MtaH5 = {
    pgv: function () {},
  };
  global.newH5IndexProps = {
    // 施予受弹窗
    shiyushou: {
      show_activity: true, // 弹窗是否显示
      activityStartTime: new Date("2000/01/01 00:00:00").getTime(), // 活动开始时间
      activityEndTime: new Date("2099/12/30 23:59:59").getTime(), // 活动结束时间
      showNum: 1, // 该入口一天显示多少次
    },
    // 重庆招联送优惠券活动
    cmb: {
      show_activity: false, // 弹窗是否显示
      activityStartTime: new Date("2019/05/05 00:00:00").getTime(), // 活动开始时间
      activityEndTime: new Date("2029/12/12 23:59:59").getTime(), // 活动结束时间
      showNum: 1, // 该入口一天显示多少次
    },
    operation1:
      '[{"title":"袋鼠商城","desc":"","pic":"/upload/imagelist/ori/ae53569fb0930ecf4e23baf71e4b951c.png","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/medicalcard-list?&from_index_for_operation=operation48","tagPic":null},{"title":"企业团检","desc":"","pic":"/upload/imagelist/ori/13b6900122459601784a002ae0de0b12.png","type":"1","url":"https://apps.daishutijian.com/sports/?from=wx_menu&from_index_for_operation=operation49","tagPic":null},{"title":"婚检孕检","desc":"","pic":"/upload/imagelist/ori/ade7914dbdd8eb95872090c5d69636b6.png","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list?package_class=4,128&sceneEntry=6&from_index_for_operation=operation8","tagPic":null},{"title":"职场体检","desc":"","pic":"/upload/imagelist/ori/263ba25b15b432ab0c8b915ce3444936.png","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list?package_class=2,127,129,147&sceneEntry=7&from_index_for_operation=operation50","tagPic":null},{"title":"父母体检","desc":"","pic":"/upload/imagelist/ori/5201c0af354e4de4e466be83ff4521d2.png","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list?package_class=6,7,42,126&sceneEntry=1&from_index_for_operation=operation51","tagPic":null}]',
    operation2:
      '[{"title":"私人定制","desc":"系统根据用户情况进行推荐","pic":"","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/questionnaire/home?&from_index_for_operation=operation26","tagPic":null},{"title":"高端体检","desc":"高端体检及防癌筛选","pic":"","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list?package_class=129&sceneEntry=2&from_index_for_operation=operation27","tagPic":null},{"title":"基因检测","desc":"了解你的前世今生","pic":"","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list?package_custom_tags=153&sceneEntry=3&from_index_for_operation=operation28","tagPic":null},{"title":"入职体检","desc":"方便快捷线上预约","pic":"/upload/imagelist/ori/09f669b30f41dee7cac5869d8544a44d.png","type":"1","url":"http://apps.daishutijian.com/wechat/h5#/package-list?packageNameLike=入职&activity_type=common&from_index_for_operation=operation29","tagPic":null}]',
    operation3:
      '[{"title":"香港体检","desc":"权威体检中心","pic":"/upload/imagelist/ori/7c3010bbed70efb2cb019767a3081342.png","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list?org_id=1901,1622&from_index_for_operation=operation56","tagPic":""},{"title":"男士体检","desc":"关爱男性健康","pic":"/upload/imagelist/ori/5316f66d79f90b2bacfa10d8d50e6562.png","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list/?for_sex_list=1&sceneEntry=4&from_index_for_operation=operation57","tagPic":""},{"title":"女士体检","desc":"呵护女性健康","pic":"/upload/imagelist/ori/ca507298fd4e7779d2a0db69aac3e31f.png","type":"1","url":"https://apps.daishutijian.com/wechat/h5#/package-list/?for_sex_list=2&sceneEntry=5&from_index_for_operation=operation58","tagPic":""}]',
    homePageNotify: {
      content: "近期发现有不法分子冒充袋鼠工作人员哄抬价.",
    },
  };
  global.orderListBanner = [
    "https://public-10006067.file.myqcloud.com/upload/imagelist/activity/6acce0783aef89184c624b3577fa014b.png",
  ];
  global.cityInfo = {
    city_id: 198,
    name: "广州",
  };
  global.defaultCityId_name = {
    city_id: 200,
    city_name: "深圳",
  };
  global.kangarooChannelIds = ["1"];
}
// 默认图片
global.defaultLogo =
  'this.src="' + require("../images/default-logo-1.png") + '"';
global.jindongChannel = "004_01_0014_0001_01";
global.isWechatSubscription = false;
global.isAndroid =
  navigator.userAgent.indexOf("Android") > -1 ||
  navigator.userAgent.indexOf("Linux") > -1; // 是否安卓系统
global.isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 是否ios系统
global.isWechat = /MicroMessenger/.test(window.navigator.userAgent); // 是否微信浏览器
global.isAlipay = /AlipayClient/.test(window.navigator.userAgent); // 是否支付宝浏览器
global.ENTRANCE = +BROSWER_TYPE === 16 ? "建行" : ENTRANCE; // 个检平台入口，根据该值设定不同的个检平台主题色
global.isFamilyDoctor = false; // 是否家庭医生用户
global.ENTRY_CHANNEL = ENTRY_CHANNEL; //渠道编码

if (process.env.NODE_ENV === "development") {
  global.healthProjectAgent =
    "//dev.daishu-component.com/health/#/project-agent";
  global.healthHome = "http://dev.daishu-component.com/health/#/";
  global.internalHospitalUrl =
    "http://dev.daishu-component.com/api/frontend/to_app/1028?attach[to]=home";
} else if (window.location.href.includes("test.")) {
  global.ZTPREFIX = "https://life.daishujiankang.com/nar-web/h5/pre/";
  global.ZTPREFIXLOGIN =
    "https://test.daishutijian.com/tijian/apps/wechat/home/covid_entrance";
  global.healthProjectAgent =
    "//test.daishutijian.com/services_component2/health/#/project-agent";
  global.healthHome =
    "https://test.daishutijian.com/services_component2/health/#/";
  global.internalHospitalUrl =
    "https://test.daishutijian.com/internet-hospital/frontend/h5/#/";
} else if (window.location.href.includes("apps.")) {
  global.ZTPREFIX = "https://www.fulizhushou.cn/apps/reservation-order/web/";
  global.ZTPREFIXLOGIN =
    "https://apps.daishutijian.com/wechat/home/covid_entrance";
  global.healthProjectAgent =
    "//apps.daishutijian.com/daishu_component/public/health/#/project-agent";
  global.healthHome = `https://${window.location.host}/daishu_component/public/health/#/`;
  global.internalHospitalUrl = `https://${window.location.host}/internet-hospital/frontend/h5/#/`;
}
